<template>
  <div>
    <div class="fixed width-100 z-99">
      <van-tabs v-model="tabIndex" @click="tableClick">
        <van-tab title="全部客户"></van-tab>
        <van-tab title="我的客户"></van-tab>
      </van-tabs>
      <!--  固定位搜索栏  -->
      <van-search class="fixed width-99 z-99" clearable shape="round" v-model="queryParams.companyName" show-action
                  @search="onSearch">
        <template #action>
          <div class="w-110 h-52 l-h-52 bg-FFDA3E b-r-28 text-center" @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>
    <!--  站位盒子  -->
    <div class="h-200"></div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list :immediate-check="false" v-model="loading" :error.sync="error" :finished="finished"
                finished-text="没有更多了" @load="getList" class="p-l-20 p-r-20 p-b-20">
        <div v-for="(item,index) in list" :key="index" class="bg-FF p-30 m-t-20 font-30 font-weight-500">
          <div class="flex">
            <img :src="`${image_base_url}/crm-icon-building.png`" class="w-50 h-50" alt="">
            <p class="m-l-20">{{ item.companyName }}</p>
          </div>

          <van-row type="flex" align="center" class="m-t-30">
            <van-col span="7">
              <div class="cor-88 font-30">客户级别</div>
            </van-col>
            <van-col span="17">
              <div class="cor-33 font-30">
                <dict-tag :options="customer_level" :value="item.companyLevel"></dict-tag>
              </div>
            </van-col>
          </van-row>

          <van-row type="flex" align="center" class="m-t-20">
            <van-col span="7">
              <div class="cor-88 font-30">行业</div>
            </van-col>
            <van-col span="17">
              <div class="cor-33 font-30">
                <dict-tag :options="customer_nature" :value="item.companyNature"></dict-tag>
              </div>
            </van-col>
          </van-row>

          <van-row type="flex" align="center" class="m-t-20">
            <van-col span="7">
              <div class="cor-88 font-30">单位类型</div>
            </van-col>
            <van-col span="17">
              <div class="cor-33 font-30">
                <dict-tag :options="customer_industry" :value="item.companyIndustry"></dict-tag>
              </div>
            </van-col>
          </van-row>
            <van-row type="flex" align="center" class="m-t-20">
            <van-col span="7">
              <div class="cor-88 font-30">客户规模</div>
            </van-col>
            <van-col span="17">
              <div class="cor-33 font-30">
                <dict-tag :options="custom_base" :value="item.customBase"></dict-tag>
              </div>
            </van-col>
          </van-row>
          <van-divider/>
          <van-row type="flex">
            <van-col :span="8" style="border-right: 1px solid #EBEBEB" @click="addVisit(item)">
              <div class="flex">
                <img class="w-36 h-36" :src="`${image_base_url}/crm-icon-add.png`">
                <p class="font-28 font-weight-500 p-l-10">拜访记录</p>
              </div>
            </van-col>
            <van-col :span="8" style="border-right: 1px solid #EBEBEB" @click="addCustomer(item)">
              <div class="flex row-center">
                <img class="w-36 h-36" :src="`${image_base_url}/crm-icon-add.png`">
                <p class="font-28 font-weight-500 p-l-10">联系人</p>
              </div>
            </van-col>
            <van-col :span="8">
              <div class="flex row-center" @click="details(item)">
                <img class="w-36 h-36" :src="`${image_base_url}/crm-icon-view.png`">
                <p class="font-28 font-weight-500 p-l-10">详情</p>
              </div>
            </van-col>
          </van-row>


        </div>
      </van-list>
    </van-pull-refresh>

    <!-- 添加 -->
    <div class="zjm-fixed-bottom pos-b-140 pos-r-20 bg-FFDB43 cor-00 font-50 " @click="onAddClick">+</div>
    <!-- 返回 -->
    <div class="zjm-fixed-bottom pos-b-20 pos-r-20 bg-FFDB43 cor-FF font-28" @click="goBack">返回</div>
  </div>
</template>
<script>
import {companyList} from '@/api/crm/index'
import {mapState} from "vuex";
import {getDictDataByType} from "@/api/dict";
import cache from "@/plugins/cache";

export default {
  name: 'client',
  computed: {
    ...mapState({
      image_base_url: state => state.settings.image_base_url,
    }),
  },
  data() {
    return {
      userId: '',
      tabIndex: 0,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      queryParams: {
        saveChecked: false,
        saveDefault: false,
        pageNum: 1,
        pageSize: 20,
        createBy: '',
        companyName: ''
      },
      routeQuery: {},
      customer_nature: [],
      // 所属行业
      customer_industry: [],
      // 客户级别
      customer_level: [],
      // 客户规模
      custom_base: []
    }
  },

  created() {
    this.queryParams = Object.assign(this.queryParams, this.$route.query)
    const userId = JSON.parse(cache.session.get('userInfo')).userId
    this.userId = userId
    getDictDataByType('customer_nature').then(res => {
      this.customer_nature = res.data
    })
    getDictDataByType('customer_industry').then(res => {
      this.customer_industry = res.data
    })
       getDictDataByType('custom_base').then(res => {
      this.custom_base = res.data
    })

    getDictDataByType('customer_level').then(res => {
      this.customer_level = res.data
    })
    this.getList()
  },
  methods: {
    addVisit(item) {
      console.log(1111111111,item)
      this.$router.push({path: '/visitAdd', query: {customerCompanyName: item.companyName, companyId: item.id}})
    },
    // 详情
    details(item) {
      this.$router.push({path: "/client/view", query: {companyId: item.id}})
    },
    addCustomer(item) {
      this.$router.push({path: '/customer/add', query: {companyId: item.id}})
    },
    tableClick(name, title) {
      this.list = [];
      this.queryParams.pageNum = 1;
      if (name == 0) {
        this.queryParams.createBy = ''
      } else {
        this.queryParams.createBy = this.userId + ',' + 1
      }
      this.getList()
    },
    // 下拉
    onRefresh() {
      this.finished = false;
      this.list = []
      this.queryParams.pageNum = 1
      this.getList();
    },
    // 添加
    onAddClick() {
      this.$router.push({path: '/client/add'})
    },
    onSearch() {
      this.finished = false
      this.queryParams.pageNum = 1;
      this.list = []
      this.getList();
    },
    getList() {
      this.loading = true;
      companyList(this.queryParams).then(res => {
        if (res.rows.length === 0) {
          this.finished = true
        }
        if (res.total == res.rows.length) {
          this.finished = true
        }
        this.list = this.list.concat(res.rows)
        this.queryParams.pageNum++
        this.loading = false;
        this.refreshing = false;
      })
    },
    goBack() {
      if (this.$route.query.lastPage) {
        this.$router.push({
          path: this.$route.query.lastPage,
          query: {
            tabIndex: this.$route.query.lastPageTabIndex
          }
        })
      } else {
        this.$router.go(-1)
      }
    },
  }
}

</script>
<style scoped>
.fixed-button {
  position: fixed;
  bottom: 20%;
  right: 50px;
  z-index: 1;
}
</style>
